import * as React from "react";
import { BaseFormElement, IBaseFormElementProps } from "../../../react-core/Html/BaseFormElement";
import { ICheckboxEditorProps, CheckboxEditor } from "../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../react-core/Html/FormComponent";

export interface ICheckboxGroupProps extends IBaseFormElementProps {
    type: "inline" | "block" | "panel" | "sr-only" | "150";
    options: ICheckboxEditorProps[];
    title?: string | JSX.Element;
    wrapCss?: string;
    srTitle?: string;
}

export interface ICheckboxGroupState {
    disable?: boolean;
}

export class CheckboxGroup extends BaseFormElement<ICheckboxGroupProps, ICheckboxGroupState> {
    constructor(props: ICheckboxGroupProps) {
        super(props);
        this.state = {};
    }

    public isValid() {
        return true;
    }

    public setDisable() {
        this.setState({ disable: true });
    }

    private getCheckbox(option: ICheckboxEditorProps, cssWrapper, index) {
        if (option !== null) {
            option.disabled = this.state.disable ? this.state.disable : option.disabled;
        } else {
            option = {};
            option.disabled = this.state.disable;
        }
        return <CheckboxEditor key={`checkbox-group-${index}`} {...option} cssWrapper={cssWrapper} />;
    }

    private getCheckboxes(options: ICheckboxEditorProps[], cssWrapper) {
        return options.map((ele, index) => {
            return this.getCheckbox(ele, cssWrapper, index);
        });
    }

    public render(): JSX.Element {
        const { type, options, title, wrapCss, srTitle } = this.props;
        let wrapperCssNew = wrapCss + " ";
        switch (type) {
            case "inline":
                wrapperCssNew += "square-checkbox";
                break;
            case "150":
                wrapperCssNew += "checkbox-layout-150";
                break;
            case "panel":
                wrapperCssNew += "checkbox-panel";
                break;
            case "block":
                wrapperCssNew += "square-checkbox block";
                break;
            case "sr-only":
                wrapperCssNew += "square-checkbox label-sr-only";
                break;
            default:
                break;
        }

        const groups = this.getCheckboxes(options, wrapperCssNew);

        let groupCss = "form-group";
        if (type == "inline") {groupCss += "  checkbox-layout-inline";}
        if (type == "150") {groupCss += "  checkbox-layout-150 mb-9";}

        return (
            <fieldset className={groupCss}>
                <legend className="sr-only">{title ? title : srTitle}</legend>
                <legend className="control-label">{title}</legend>
                <div className="controls-wrap">{groups}</div>
            </fieldset>
        );
    }
}
